import axios from './index';

// 分页查询简历信息
export const fetchResumeList = (data) => {
  return axios.post('/api/common/homePage/resume/queryJd', data);
};

// 分页查询简历token
export const fetchResumeToken = (data) => {
  return axios.post('/api/common/homePage/resume/queryTokens', data);
};

// 查询简历信息by token
export const fetchResumeListByToken = (data) => {
  return axios.post('/api/common/homePage/resume/queryPageByTokens', data);
};

// upload jd
export const uploadJd = (data) => {
  return axios.post('/api/common/homePage/uploadJd', data);
};

// 查看简历的详情
export const fetchResumeDetaileByToken = (data) => {
  return axios.post('/api/common/homePage/resume/detail', data);
};

// 查看简历点赞情况
export const fetchResumeLike = (data) => {
  return axios.post('/api/common/resumeLike/check', data);
};

// 简历点赞-取消
export const submitResumeLike = (data) => {
  return axios.post('/api/common/resumeLike/toggle', data);
};

// 查看简历收藏情况
export const fetchResumeFavorite = (data) => {
  return axios.post('/api/common/resumeFavorite/check', data);
};

// 简历收藏-取消
export const submitResumeFavorite = (data) => {
  return axios.post('/api/common/resumeFavorite/toggle', data);
};

// 举报信息
export const submitResumeReport = (data) => {
  return axios.post('/api/common/resumeReport/add', data);
};

// 查询广告页面
export const fetchAdvertisementList = () => {
  return axios.get('/api/common/homePage/advertisement/list');
};
